export default <FieldType>(name: string) => {
  const id = useId()

  const { value, errorMessage, handleBlur, handleChange, setValue } =
    useField<FieldType>(
      () => name,
      {},
      {
        validateOnValueUpdate: false,
      },
    )

  return {
    id,
    value,
    errorMessage,
    handleBlur,
    handleChange,
    setValue,
  }
}
